module.exports = __webpack_public_path__ + "img/access-denied.1d1d0015.png";